/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import MediaField from '@organisms/MediaField';
import { ContentModuleModal, TextField } from '@molecules';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS } from './constants';
import Item from './Item';
import RichTextField from '@components/molecules/RichTextField';
import BackgroundSelect from '../BackgroundSelect';

const TimeTable = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues: data,
  errors,
  isUltimateDesign,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);

  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  return (
    <>
      <ContentModuleModal
        visible={visible}
        title="Timetable"
        subtitle="Shows the timetable of the current event."
        okText={onDelete ? 'SAVE CHANGES' : 'ADD TIMETABLE'}
        onCancel={handleClose}
        onSubmit={form.submit}
        onDelete={onDelete}
        heroImageSrc={previewImg}
        errors={errors}
      >
        <Form
          form={form}
          layout="vertical"
          wrapperCol={{ span: 24 }}
          initialValues={initialValues}
          onSerializedFinish={handleSubmit}
        >
          {isUltimateDesign ? (
            <>
              <TextField {...FORM_FIELD.TITLE} />
              <TextField {...FORM_FIELD.SUBTITLE} />
              <RichTextField {...FORM_FIELD.TABLE_CONTENT} />
              <BackgroundSelect
                isImgBackground={!!data?.backgroundImageId}
                background={FORM_FIELD.BACKGROUND}
                backgroundColours={FORM_FIELD.BACKGROUND_COLOUR}
              />
            </>
          ) : (
            <MediaField {...FORM_FIELD.IMAGE} style={NO_MARGIN_BOTTOM} />
          )}
        </Form>
      </ContentModuleModal>
    </>
  );
};

TimeTable.Item = Item;

export default TimeTable;
